import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { broadcastPaths } from "@/react/helpers/urlHelpers/broadcastPaths";
import { useChecklistApi } from "@/react/hooks/useChecklistApi";
import { communitiesPaths } from "../helpers/routerPathHelpers";

export const useCreateFirstBroadcast = () => {
  const history = useHistory();
  const gettingStartedPath = communitiesPaths.onboarding();
  const { fetchBroadcast } = useChecklistApi();

  const createFirstBroadcast = useCallback(
    () =>
      new Promise<void>((resolve, reject) => {
        fetchBroadcast(undefined, {
          onSuccess: ({ broadcast_id: broadcastId }) => {
            history.push({
              pathname: broadcastPaths.edit({ broadcastId }),
              state: { isNewBroadcast: true, from: gettingStartedPath },
            });
            resolve();
          },
          onError: reject,
        });
      }),
    [fetchBroadcast, history, gettingStartedPath],
  );

  return { createFirstBroadcast };
};
